import {
	fetch,
    fetchForCVO,
	sconfig,
} from '@/config/fetch'
const product = require('@/service/mock/product')
if (sconfig.all||(!sconfig.all&&sconfig.order)) {
	
}
else{
	var getMeetingRooms = (token,vipno,params) => fetchForCVO('GET','ss_001',token,vipno,params)
	var getMeetingRoom = (token,vipno,params) => fetchForCVO('GET','ss_001',token,vipno,params)
	var getMeetingDurations = (token,vipno,params) => fetchForCVO('GET','ss_002',token,vipno,params)
	var postReservationRooms = (token,vipno,params) => fetchForCVO('POST','ss_003',token,vipno,params)
	var getReservationOrders = (token,vipno,params) => fetchForCVO('GET','ss_006',token,vipno,params)
	var getReservationCalendar = (token,vipno,params) => fetchForCVO('GET','ss_009',token,vipno,params)
	var getReservationCart = (token,vipno,params) => fetchForCVO('GET','ss_004',token,vipno,params)
	var getReservationDetail = (token,vipno,params) => fetchForCVO('GET','ss_007',token,vipno,params)
	var postReservationAdditional = (token,vipno,params) => fetchForCVO('POST','ss_005',token,vipno,params)
	var postDeterminePaymentuser = (token,vipno,params) => fetchForCVO('POST','SS_018',token,vipno,params) // 代缴用户
	var postCancelReservation = (token,vipno,params) => fetchForCVO('GET','ss_008',token,vipno,params)
	var getStores = (token,vipno,params) => fetchForCVO('GET','ss_010',token,vipno,params)
	var getUserRank = (token,vipno) => fetchForCVO('GET','ss_011', token,vipno)
	var getMeetingOrderTime = (token,vipno,ParentCode,Code) => fetchForCVO('GET','ss_012',token,vipno,{ParentCode,Code})
	var postAloneCancel = (token,vipno,params) => fetchForCVO('POST','SS_019',token,vipno,params)
	var getQRcode = (token,vipno,params) => fetchForCVO('GET','ss_020',token,vipno,params) // 获取杉德支付二维码
	var getPaySwitch = (token,vipno) => fetchForCVO('GET','ss_021',token,vipno) // 判定支付方式切换
	var getMeetingOrderStatus = (token,vipno,OrderNo) => fetchForCVO('GET','SS_022',token,vipno,{OrderNo}) // 获取订单状态
	// 研发中心
	var getRDMeetingRooms = (token,vipno) => fetchForCVO('GET','ss_013',token,vipno)
	var postRDMeetingRooms = (token,vipno,params) => fetchForCVO('POST','ss_015',token,vipno,params)
	var getRDuserInfo = (token,vipno) => fetchForCVO('GET','ss_016',token,vipno)
	var checkRDPermissions = (token,vipno) => fetchForCVO('GET','Home_11',token,vipno,{code:'RDMeeting'})
	var postChangeMobile = (token,vipno,params) => fetchForCVO('POST','ss_017',token,vipno,params)
}

export {
	getMeetingRooms,
	getMeetingRoom,
	getMeetingDurations,
	postReservationRooms,
	getReservationOrders,
	getReservationCalendar,
	getReservationCart,
	getReservationDetail,
	postReservationAdditional,
	postDeterminePaymentuser,
	postCancelReservation,
	getStores,
	getUserRank,
	getMeetingOrderTime,
	postAloneCancel,
	getQRcode,
	getPaySwitch,
	getMeetingOrderStatus,
	getRDMeetingRooms,
	postRDMeetingRooms,
	getRDuserInfo,
	checkRDPermissions,
	postChangeMobile,
}